export { BannersSliderPrimary, Container } from './BannersSliderPrimary';
